const QUERY_PARAM_DENYLIST = [
  'token',
  'access_token',
  'refresh_token',
  'code',
  'otp',
  'password',
  'secret',
  'signature',
  'jwt',
]

const MASKED_VALUE = '***'

const isSensitiveParamKey = (key: string): boolean => {
  const normalizedKey = key.toLowerCase()
  return QUERY_PARAM_DENYLIST.some(
    token => normalizedKey === token || normalizedKey.includes(token),
  )
}

export const maskSensitiveQueryString = (queryString: string): string => {
  const normalizedQueryString = queryString.startsWith('?')
    ? queryString.slice(1)
    : queryString

  if (!normalizedQueryString) {
    return ''
  }

  const params = new URLSearchParams(normalizedQueryString)
  const maskedParams = new URLSearchParams()

  params.forEach((value, key) => {
    maskedParams.append(key, isSensitiveParamKey(key) ? MASKED_VALUE : value)
  })

  return maskedParams.toString()
}

export const shouldTrackPagePath = (pathname: string): boolean => {
  const normalizedPathname = pathname.toLowerCase()
  return ![
    '/login',
    '/forgot-password',
    '/reset-password',
    '/external-auth',
    '/admin/login',
    '/admin/forgot-password',
    '/admin/reset-password',
  ].some(path => normalizedPathname === path)
}

export const shouldTrackGA4PagePath = (pathname: string): boolean => {
  const normalizedPathname = pathname.toLowerCase()

  if (
    ['/', '/dashboard', '/admin/access-log', '/admin/user-list'].includes(
      normalizedPathname,
    )
  ) {
    return false
  }

  const segmentCount = normalizedPathname.split('/').filter(Boolean).length
  return segmentCount >= 3
}
